export const SKILLS_DISPLAY_STYLE_ENUM = {
  TABLE: 'table',
  CHART: 'chart'
};
export const DEFAULT_SKILLS_DISPLAY_STYLE = SKILLS_DISPLAY_STYLE_ENUM.CHART;
